export default __webpack_public_path__ + "static/pic4-4897a9e4219c45e9e411599b5267968f.png";